import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { coinsAdminApi } from "../../api/coinsAdminApi";
var COINS_KEY = "admin-coins";
export var useAdminCoins = function () {
    return useQuery({ queryKey: [COINS_KEY], queryFn: coinsAdminApi.getAll });
};
export var useCoinUpsertImg = function () {
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) {
            var coinId = _a.coinId, file = _a.file;
            return coinsAdminApi.upsertImg(coinId, file);
        },
        onSuccess: function () {
            queryClient.invalidateQueries({ queryKey: [COINS_KEY] });
        },
    });
};
